import { ROUTES, servicePath } from "./routes";
import { absoluteCanonical, buildBreadcrumbs, buildSchemaGraph, SITE_ORIGIN } from "./schemaOrg";

export { SITE_ORIGIN, absoluteCanonical, buildBreadcrumbs };

export const SERVICE_SLUGS = ["social-media-management", "ads", "website", "consultanta"];

function truncate(text, max = 160) {
  if (!text) return "";
  const clean = String(text).replace(/\s+/g, " ").trim();
  if (clean.length <= max) return clean;
  return `${clean.slice(0, max - 1).trim()}…`;
}

function homeSeo(lang, t, brandingSeo) {
  return {
    title: brandingSeo.siteTitle,
    description: brandingSeo.metaDescription,
    path: ROUTES.home,
  };
}

function staticPageSeo(lang, path, title, description) {
  const suffix = " | Social Destiny";
  return {
    title: `${title}${suffix}`,
    description: truncate(description),
    path,
  };
}

/**
 * @param {string} pathname
 * @param {{ slug?: string }} params
 * @param {'ro'|'en'} lang
 * @param {object} t - merged translations
 * @param {object|null} serviceData - merged service page
 * @param {object} brandingSeo - branding.seo[lang] merged with defaults
 */
export function resolvePageSeo(pathname, params, lang, t, serviceData, brandingSeo) {
  const path = pathname.replace(/\/$/, "") || "/";

  if (path === ROUTES.home || path === "/") {
    return homeSeo(lang, t, brandingSeo);
  }

  if (path === ROUTES.services) {
    return staticPageSeo(
      lang,
      ROUTES.services,
      lang === "en" ? "Services" : "Servicii",
      t.services_page?.subtitle || t.services_page?.title
    );
  }

  if (path.startsWith(`${ROUTES.services}/`)) {
    const slug = params.slug || path.split("/").pop();
    if (serviceData) {
      return staticPageSeo(lang, servicePath(slug), serviceData.title, serviceData.lead || serviceData.intro_body);
    }
  }

  if (path === ROUTES.portfolio) {
    return staticPageSeo(lang, ROUTES.portfolio, lang === "en" ? "Portfolio" : "Portofoliu", t.portfolio?.subtitle || t.portfolio?.title);
  }

  if (path === ROUTES.about) {
    return staticPageSeo(lang, ROUTES.about, lang === "en" ? "About us" : "Despre noi", t.about?.lead || t.about?.title);
  }

  if (path === ROUTES.contact) {
    return staticPageSeo(lang, ROUTES.contact, lang === "en" ? "Contact" : "Contact", t.contact?.subtitle || t.contact?.title);
  }

  if (path === ROUTES.privacy) {
    return staticPageSeo(
      lang,
      ROUTES.privacy,
      lang === "en" ? "Privacy Policy" : "Politica de confidențialitate",
      t.legal?.privacy?.title || "Social Destiny"
    );
  }

  if (path === ROUTES.terms) {
    return staticPageSeo(
      lang,
      ROUTES.terms,
      lang === "en" ? "Terms & Conditions" : "Termeni și condiții",
      t.legal?.terms?.title || "Social Destiny"
    );
  }

  if (path === ROUTES.cookies) {
    return staticPageSeo(
      lang,
      ROUTES.cookies,
      lang === "en" ? "Cookie Policy" : "Politica de cookie-uri",
      t.legal?.cookies?.title || "Social Destiny"
    );
  }

  return homeSeo(lang, t, brandingSeo);
}

export function buildJsonLd({ pathname, lang, t, serviceData, contactInfo, pageSeo }) {
  return buildSchemaGraph({
    pathname,
    lang,
    t,
    serviceData,
    contactInfo,
    pageSeo,
    origin: SITE_ORIGIN,
  });
}
